import React from 'react'
import './header.css'
import { useBranding } from "../../branding/BrandingProvider";
import HoverMenu from "../hover-menu/HoverMenu";
import menuMan from "../../assets/burger-menu-icon.png";

export default function Header() {
    const brand = useBranding();

    return (<div className='main-header'>
        {brand.logo && <img className='logo' alt={brand.name} src={brand.logo} onClick={() => { window.location = '/' }} />}
        {process.env.REACT_APP_ENVIRONMENT === 'DEV' && <h3>DEVELOPMENT</h3>}
        <HoverMenu im={menuMan} />
    </div>)
}
